export default "__VITE_ASSET__BGjEqYGV__"